import $ from 'jquery'
import { ready } from 'shared/ready'
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'
import Headroom from 'headroom.js'
import { trackInternalEvent } from '@rio/tracking'
import { getPageLabel } from '../constants/pages'

const addNavigationEvent = (value, copyText, menuSection) => {
  trackInternalEvent('click_website_menu', {
    website_host: window.location.host,
    targetUrl: value.href,
    copy: copyText,
    menu_section: menuSection || 'navigation',
    label: getPageLabel(window.location.pathname),
  })
}

class Nav {
  constructor($el) {
    if ($el.length === 0) return
    this.$el = $el

    this.initDropdownMenu()
    this.initHeadroom()
    this.initMobileMenu()
  }

  initMobileMenu() {
    this.isMenuVisible = false
    this.$menu = this.$el.find('.nav__menu')
    this.$hamburger = this.$el.find('.nav__bar-hamburger')
    this.$hamburger.on('click', this.toggleMobileMenu.bind(this))
    $(window).on('resize', this.handleResize.bind(this))
  }

  handleResize() {
    if (this.isMenuVisible && window.innerWidth > 1023) this.toggleMobileMenu()
  }

  toggleMobileMenu() {
    this.isMenuVisible = !this.isMenuVisible
    this.$el.toggleClass('is-menu-opened', this.isMenuVisible)
    this.$menu.toggleClass('is-visible', this.isMenuVisible)
    this.$hamburger.toggleClass('is-menu-visible', this.isMenuVisible)

    const updateBodyScroll = this.isMenuVisible ? disableBodyScroll : enableBodyScroll
    updateBodyScroll(this.$menu.get(0))
  }

  initDropdownMenu() {
    const view = this
    view.categories = {}
    view.visibleContent = null

    view.$triggers = this.$el.find('[data-trigger]')
    view.$dropdown = this.$el.find('.nav__dropdown')
    view.$content = this.$el.find('[data-content]')

    view.$triggers.each(function (index) {
      const name = $(this).attr('data-trigger')
      const $content = view.$el.find(`[data-content=${name}]`)

      view.categories[name] = {
        trigger: $(this),
        content: $content,
      }

      if (index === 0) {
        view.$dropdown.height($content.height())
        // Fix wrong default height (related to fonts loading)
        $(window).on('load.nav', () => view.$dropdown.height($content.height()))
      }
    })

    view.$triggers.on('mouseleave', view.handleMouseLeave.bind(this))
    view.$dropdown.on('mouseleave', view.handleMouseLeave.bind(this))
    view.$triggers.on('mouseenter', view.handleMouseEnter.bind(this))
    view.$dropdown.on('mouseenter', view.handleMouseEnter.bind(this))

    view.$triggers.on('mouseleave', () => clearTimeout(view.showTimer))
    view.$triggers.on('mouseenter', function () {
      view.showTimer = setTimeout(() => view.showContent($(this).attr('data-trigger')), 100)
      $(window).off('load.nav')
    })

    const links = this.$el.find('.nav__bar-link')
    if (links) {
      links.each((index, value) =>
        value.addEventListener('click', function (event) {
          trackInternalEvent('click_website_menu', {
            website_host: window.location.host,
            targetUrl: value.href,
            copy: value.innerText,
            menu_section: value.getAttribute('data-trigger') || value.innerText,
            label: getPageLabel(window.location.pathname),
          })
        }),
      )
    }

    const logo = this.$el.find('.nav__bar-logo-rio')
    if (logo) {
      logo.each((index, value) =>
        value.addEventListener('click', () => addNavigationEvent(value, 'logo')),
      )
    }

    const myAccountSignedIn = this.$el.find('#my_account_signed_in')
    if (myAccountSignedIn) {
      myAccountSignedIn.each((index, value) =>
        value.addEventListener('click', () => addNavigationEvent(value, 'My Account')),
      )
    }

    const myAccount = this.$el.find('#my_account')
    if (myAccount) {
      myAccount.each((index, value) =>
        value.addEventListener('click', () => addNavigationEvent(value, 'My Account')),
      )
    }

    const buildResume = this.$el.find('#build_resume')
    if (buildResume) {
      buildResume.each((index, value) => {
        value.addEventListener('click', () => {
          addNavigationEvent(value, 'Build my resume')
          trackInternalEvent('click_sign_up', {
            block: $(window).scrollTop() > 0 ? 'sticky' : 'static',
            label: getPageLabel(window.location.pathname),
          })
        })
      })
    }

    const mobileMyAccountSignedIn = this.$el.find('#mobile_my_account_signed_in')
    if (mobileMyAccountSignedIn) {
      mobileMyAccountSignedIn.each((index, value) =>
        value.addEventListener('click', () => addNavigationEvent(value, 'My Account')),
      )
    }

    const mobileMyAccount = this.$el.find('#mobile_my_account')
    if (mobileMyAccount) {
      mobileMyAccount.each((index, value) =>
        value.addEventListener('click', () => addNavigationEvent(value, 'My Account')),
      )
    }

    const menuBuildResume = this.$el.find('#mobile_build_resume')
    if (menuBuildResume) {
      menuBuildResume.each((index, value) => {
        value.addEventListener('click', () => {
          addNavigationEvent(value, 'Build my resume')
          trackInternalEvent('click_sign_up', {
            block: $(window).scrollTop() > 0 ? 'sticky' : 'static',
            label: getPageLabel(window.location.pathname),
          })
        })
      })
    }

    const navDropdownHeaderTitle = this.$el.find('.nav__dropdown-header-title')
    if (navDropdownHeaderTitle) {
      navDropdownHeaderTitle.each((index, value) => {
        const menuSection = $(value).closest('[data-content]').attr('data-content')
        return value.addEventListener('click', () =>
          addNavigationEvent(value, value.innerText, menuSection),
        )
      })
    }

    const navDropdownCat = this.$el.find('.nav__template-cat')
    if (navDropdownCat) {
      navDropdownCat.each((index, value) => {
        const menuSection = $(value).closest('[data-content]').attr('data-content')
        const title = $(value).find('.nav__template-cat-title').text().trim()
        return value.addEventListener('click', () => addNavigationEvent(value, title), menuSection)
      })
    }

    const navDropdownSidebarLink = this.$el.find('.nav__dropdown-sidebar-link')
    if (navDropdownSidebarLink) {
      navDropdownSidebarLink.each((index, value) => {
        const menuSection = $(value).closest('[data-content]').attr('data-content')
        const title = $(value)
          .find('.nav__dropdown-sidebar-title-updated')
          .text()
          .trim()
        console.log(title)
        return value.addEventListener('click', () =>
          addNavigationEvent(value, value.innerText, menuSection),
        )
      })
    }

    const navExamplesItem = this.$el.find('.nav__examples-item')
    if (navExamplesItem) {
      navExamplesItem.each((index, value) => {
        const menuSection = $(value).closest('[data-content]').attr('data-content')
        return value.addEventListener('click', () =>
          addNavigationEvent(value, value.innerText, menuSection),
        )
      })
    }

    const navExamplesAction = this.$el.find('.nav__examples-action.nav__dropdown-action')
    if (navExamplesAction) {
      navExamplesAction.each((index, value) => {
        const menuSection = $(value).closest('[data-content]').attr('data-content')
        return value.addEventListener('click', () =>
          addNavigationEvent(value, value.innerText, menuSection),
        )
      })
    }

    const blogHeaderPostLink = this.$el.find('.blog_header_post_link')
    if (blogHeaderPostLink) {
      blogHeaderPostLink.each((index, value) => {
        const menuSection = $(value).closest('[data-content]').attr('data-content')
        return value.addEventListener('click', () =>
          addNavigationEvent(value, value.innerText, menuSection),
        )
      })
    }

    const mobileNavMenuLink = this.$el.find('.nav__menu-link')
    if (mobileNavMenuLink) {
      mobileNavMenuLink.each((index, value) =>
        value.addEventListener('click', () =>
          addNavigationEvent(value, value.innerText, 'mobile_navigation'),
        ),
      )
    }

    const mobileNavMenuSecondaryLink = this.$el.find('.nav__menu-secondary-link')
    if (mobileNavMenuSecondaryLink) {
      mobileNavMenuSecondaryLink.each((index, value) =>
        value.addEventListener('click', () =>
          addNavigationEvent(value, value.innerText, 'mobile_navigation'),
        ),
      )
    }

    const mobileNavMenuSublink = this.$el.find('.nav__menu-sublink')
    if (mobileNavMenuSublink) {
      mobileNavMenuSublink.each((index, value) =>
        value.addEventListener('click', () =>
          addNavigationEvent(value, value.innerText, 'mobile_navigation'),
        ),
      )
    }

    const mobileViewAllButton = this.$el.find('.view-all-button')
    if (mobileViewAllButton) {
      mobileViewAllButton.each((index, value) =>
        value.addEventListener('click', () =>
          addNavigationEvent(value, value.innerText, 'mobile_navigation'),
        ),
      )
    }

    const mobileMenuButton = this.$el.find('.nav__bar-hamburger')
    if (mobileMenuButton) {
      mobileMenuButton.each((index, value) =>
        value.addEventListener('click', () =>
          trackInternalEvent('open_website_menu', {
            menu_section: 'mobile_navigation',
            website_host: window.location.host,
            copy: 'Menu',
            label: getPageLabel(window.location.pathname),
          }),
        ),
      )
    }
  }

  hideContent(name) {
    this.categories[name].trigger.removeClass('is-content-active')
    this.categories[name].content.removeClass('is-visible')
    this.visibleContent = null
  }

  showContent(name) {
    if (this.visibleContent) this.hideContent(this.visibleContent)

    this.categories[name].trigger.addClass('is-content-active')
    this.categories[name].content.addClass('is-visible')

    trackInternalEvent('open_website_menu', {
      menu_section: name,
      website_host: window.location.host,
      copy: this.categories[name].trigger[0].innerText,
      label: getPageLabel(window.location.pathname),
    })

    this.$dropdown.height(this.categories[name].content.height())
    this.toggleDropdown(true)

    this.visibleContent = name
  }

  toggleDropdown(visible) {
    this.$el.toggleClass('is-dropdown-visible', visible)
    this.$dropdown.toggleClass('is-visible', visible).toggleClass('is-hidden', !visible)

    visible ? this.headroom.freeze() : this.headroom.unfreeze()
  }

  handleMouseEnter() {
    clearTimeout(this.hideTimer)
  }

  handleMouseLeave() {
    this.hideTimer = setTimeout(() => this.toggleDropdown(false), 50)
  }

  initHeadroom() {
    const makeNavSticky = this.$el.hasClass('make--sticky')
    const offset = makeNavSticky ? null : 100

    this.headroom = new Headroom(this.$el.get(0), {
      offset,
      tolerance: 10,
      classes: {
        pinned: 'nav--pinned',
        unpinned: 'nav--unpinned',
      },
    })

    const updateState = () => {
      const shouldUseHeadroom = !makeNavSticky && window.innerWidth > 1023
      const { initialised } = this.headroom

      if (shouldUseHeadroom && !initialised) {
        this.headroom.init()
      } else if (!shouldUseHeadroom && initialised) {
        this.headroom.destroy()
      }
    }

    $(window).on('resize', updateState)
    updateState()
  }
}

ready(function () {
  new Nav($('.nav'))
})
